var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('iframe',{attrs:{"src":_vm.detailUil,"frameborder":"0","scrolling":"no","id":"iframe_one"}})])}
var staticRenderFns = []

export { render, staticRenderFns }